import { render } from "./GiniChart.vue?vue&type=template&id=3319f467&scoped=true"
import script from "./GiniChart.vue?vue&type=script&lang=js"
export * from "./GiniChart.vue?vue&type=script&lang=js"

import "./GiniChart.vue?vue&type=style&index=0&id=3319f467&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3319f467"]])

export default __exports__